import { getOption, isOpenBox } from "../../lib/product-utils";

export function resolveVariant(variants, { size, option, openBox }) {
  let selectedVariant = variants[0];
  if (size && option) {
    selectedVariant = variants.find(
  (variant) => (getOption(variant, option)?.toLowerCase() === size.toLowerCase() && isOpenBox(variant) === openBox)
    );
  }

  if (!selectedVariant) {
    selectedVariant = variants[0];
  }

  return selectedVariant;
}
